import classNames from 'classnames';
import dayjs from 'dayjs';
import { Placement } from 'popper.js';
import React, { useEffect, useRef, useState } from 'react';
import { HasClassName } from '../component-utils';
import Input from './Input';
import { Menu, MenuItem } from './Menu';
import './TimePicker.scss';

interface Props extends HasClassName {
  value: number
  onChange(value: number): void
  placement?: Placement
  disabled?: boolean
}

const Minutes = Array.from(new Array(48)).map((_, i) => i * 30);

export default function TimePicker({ className, value, onChange, placement = 'bottom-start', disabled }: Props) {
  const [ text, setText ] = useState('')
  const [ isOpen, setOpen ] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setText(format(value))
  }, [ value ])

  function onBlur() {
    const parsed = dayjs('01/01/00001 ' + text)
    if (parsed.isValid()) {
      onChange(parsed.diff(parsed.startOf('d'), 'm'))
    }
  }

  return <div className={classNames('TimePicker', className)}>
    <Input className='TimePickerInput' innerRef={inputRef} disabled={disabled}
        onFocus={() => setOpen(true)} value={text} onChange={e => setText(e.currentTarget.value)}
        onBlur={onBlur} autocomplete={false}/>
    <Menu open={isOpen} onClose={() => setOpen(false)} className='TimePickerPopup' target={inputRef.current} placement={placement}>
      {Minutes.map(min => <MenuItem key={min} onClick={() => onChange(min)} preselect={Math.abs(value - min - 0.1) < 15}>
        {format(min)}
      </MenuItem>)}
    </Menu>
  </div>
}

function format(min: number) {
  return dayjs.utc(0).add(min, 'm').format('LT')
}
